<template>
  <a-modal
    :visible="value"
    title="Save new color theme"
    width="700px"
    destroyOnClose
    @cancel="$emit('close')"
  >
    <div class="theme-modal">
      <div class="section">
        <h6 class="section__title">Global</h6>
        <ul class="grid">
          <li>
            <div class="label">Color Scheme</div>
            <div class="value">
              {{ theme.schema }}
            </div>
          </li>
        </ul>
      </div>

      <div class="section">
        <h6 class="section__title">Header buttons</h6>
        <ul class="grid">
          <li>
            <div class="label">Text color</div>
            <div class="value">
              {{ normalizeColor(theme.headerButton.textColor) }}
            </div>
          </li>
          <li>
            <div class="label">Background color</div>
            <div class="value">
              {{ normalizeColor(theme.headerButton.bgColor) }}
            </div>
          </li>
        </ul>
      </div>

      <div class="section">
        <h6 class="section__title">Main</h6>
        <ul class="grid">
          <li>
            <div class="label">Main color</div>
            <div class="value">
              {{ `${theme.main.fill} ${normalizeColor(theme.main.mainColor)}` }}
            </div>
          </li>
          <li>
            <div class="label">Background color</div>
            <div class="value">{{ normalizeColor(theme.main.bgColor) }}</div>
          </li>
          <li>
            <div class="label">Overlay color</div>
            <div class="value">
              {{ normalizeColor(theme.main.overlayColor) }}
            </div>
          </li>
          <li>
            <div class="label">Text color</div>
            <div class="value">{{ normalizeColor(theme.main.textColor) }}</div>
          </li>
          <li>
            <div class="label">Icon color</div>
            <div class="value">{{ normalizeColor(theme.main.iconColor) }}</div>
          </li>
        </ul>
      </div>

      <div class="section">
        <h6 class="section__title">Filter</h6>
        <ul class="grid">
          <li>
            <div class="label">Active color</div>
            <div class="value">
              {{ normalizeColor(theme.filter.activeColor) }}
            </div>
          </li>
          <li>
            <div class="label">Content on active color</div>
            <div class="value">
              {{ normalizeColor(theme.filter.contentColor) }}
            </div>
          </li>
        </ul>
      </div>

      <a-form-model :model="form" :rules="rules" ref="customThemeForm">
        <a-form-model-item class="name-field" :colon="false" prop="name" label="Theme name">
          <a-input
            v-model="form.name"
            size="large"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template slot="footer">
      <a-button key="cancel" @click="$emit('close')">Cancel</a-button>
      <a-button key="save" type="primary" @click="handleSubmit">
        Save
      </a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name: '',
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Please enter a theme name',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.customThemeForm.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form)
        }
      })
    },
    normalizeColor(hex) {
      return hex?.slice(1)
    },
  },
}
</script>
<style lang="scss" scoped>
.theme-modal {
  .section:not(:last-child) {
    margin-bottom: 24px;
  }

  .section__title {
    font-size: 16px;
    line-height: 1.2;
    font-weight: 600;
    color: #262626;
  }

  .grid {
    padding: 0;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 16px;
    row-gap: 8px;
  }

  .label,
  .value {
    font-size: 14px;
    line-height: 22px;
    color: #bfbfbf;
  }

  .value {
    color: #262626;
    text-transform: capitalize;
  }

  .name-field {
    max-width: 433px;
  }
}
</style>
